export default "__VITE_ASSET__CCh8Bdg5__"